import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router';
import { store } from '@/store';
import qs from 'qs';
import { getToken } from '@/helpers/http';
import parentRoutes from '@/router/parentRoutes';
import childRoutes from '@/router/childRoutes';
import { MESSAGE_MAP } from '@/config/message';
import { CommonConstants } from '@/config/constant';

let useLoginSms = '';
const routes = [
  {
    path: '/premium4',
    component: () => '',
    redirect: '/premium'
  },
  ...parentRoutes,
  ...childRoutes,
];

let title = 'GMOデジタルPay';

const mode = window.location.href.includes('#') ? createWebHashHistory() : createWebHistory();

// Hàm xử lý scroll behavior
const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition;
  } else {
    return { left: 0, top: 0 };
  }
};

const router = createRouter({
  history: mode,
  routes,
  parseQuery(query) {
    return qs.parse(query);
  },
  scrollBehavior,
});

const checkIfRedirect404 = (to) => {
  if (to.meta.creditRequired && !store.getters['event/isCreditChargeType']) {
    return true;
  }
  if (to.name.includes('Monitoring') && !store.getters['event/monitoringFlag']) {
    return true;
  }
  if (to.name.includes('MonitoringEntry') && store.getters['mimamori/isFullMonitoringList']) {
    return true;
  }
  if (to.name === 'Authentication' && !store.getters['event/childEventInfo']?.useAuthentication) {
    return true;
  }
  if (to.meta?.useVerify && (!store.getters['event/useVerify'] || (['IdentityConfirm', 'IdentityFinish'].includes(to.name) && !store.getters['event/identityVerification']))) {
    return true;
  }
  if (to.meta?.useSms && (!store.getters['event/useSms'] || (store.getters['event/parentEventInfo']?.useLinkageNecFlag && (!store.getters['auth/infor']?.email || store.getters['auth/infor']?.registSmsByNec)))) {
    return true;
  }
  if (to.meta?.isSecurityMail && (store.getters['event/parentEventInfo']?.useLinkageNecFlag && (!store.getters['auth/infor']?.mobilephone || store.getters['auth/infor']?.registEmailByNec))) {
    return true;
  }
  if ((to.meta?.useLoginSms || to.meta?.isLoggedSms) && store.getters['event/parentEventInfo']?.isLoginNormal) {
    return true;
  }
  if (to.meta?.isEmailPassword && store.getters['event/parentEventInfo']?.isLoginOnlyPhone) {
    return true;
  }
  if (to.meta?.isLoggedSms && !['EntrySms', 'EntrySmsCode'].includes(to.name) && store.getters['event/isBlockedSms']) {
    return true;
  }
  if (to.meta?.isNotLoggedSms && (store.getters['event/parentEventInfo']?.isLoginOnlyPhone || store.getters['event/parentEventInfo']?.isLoginPhone)) {
    return true;
  }
  if (to.name === 'ChargeStoreQr' && !store.getters['event/childEventInfo']?.chargeType?.store?.use) {
    return true;
  }
  if (['EntryOptional', 'EntryOptionalQR'].includes(to.name) && !store.getters['event/parentEventInfo']?.useSwitchCPMCard) {
    return true;
  }
  if (to.name === 'PincodeDefault' && store.getters['auth/hasPasscode']) {
    return true;
  }
  if (to.name === 'AccountIdentityConfirm' && !(store.getters['event/useVerify'] && store.getters['event/identityVerification'] &&
  (store.getters['event/hasTypeMomentIdentity'] || store.getters['event/requestTypeMomentIdentity']))) {
    return true;
  }
  if ((store.getters['common/isLinkageView'] || store.getters['event/appType']) && to.meta?.notUseLinkageApp) {
    return true;
  }
  if (store.getters['event/useLinkageAppAndNecFlag'] && to.meta?.isIdentitySms && !store.getters['auth/infor']?.email) {
    return true;
  }
  if (to.meta?.isNotUseLinkageNecFlag && store.getters['event/parentEventInfo'].useLinkageNecFlag) {
    return true;
  }
  if (to.meta?.isContactPage && store.getters['event/parentEventInfo'].useLinkageNecFlag && store.getters['event/nativeType']) {
    return true;
  }
  if (to.name.includes('ContactChild') && !store.getters['event/childEventInfo']?.useContactFrontFlag) {
    return true;
  }
  if (to.name === 'PayBarcode' && !store.getters['event/usePosFlag']) {
    return true;
  }
  if (to.name === 'TransferCpm' && !store.getters['event/parentEventInfo']?.useTransferBalanceCpm) {
    return true;
  }
  return false;
};

const checkIfRedirectUrl = (to, from, next) => {
  const childEventInfo = store.getters['event/childEventInfo'];
  const parentEventInfo = store.getters['event/parentEventInfo'];
  if (to.name !== '404' && ((!to.params.directory && parentEventInfo?.allChildEventEnd && !parentEventInfo?.urlFaqCustomer) ||
    (to.params.directory && childEventInfo?.expiredEvent && !childEventInfo?.urlFaqCustomer))) {
    return next({ name: '404' });
  }

  if (to.params.directory && childEventInfo?.expiredEvent && !!childEventInfo?.urlFaqCustomer) {
    window.location.replace(childEventInfo?.urlFaqCustomer);
    return false;
  } else if (!to.params.directory && parentEventInfo?.allChildEventEnd && !!parentEventInfo?.urlFaqCustomer) {
    window.location.replace(parentEventInfo?.urlFaqCustomer);
    return false;
  }
  return true;
};

const checkIfChangeSmsLayout = (to) => {
  const isLoginStream = to.name.includes('Login') && !((useLoginSms === CommonConstants.typeEmail && store.getters['event/parentEventInfo']?.isLoginPhone) || (useLoginSms === CommonConstants.typeSms && store.getters['event/parentEventInfo']?.isLoginPhoneOrMail));
  const isEntryStream = to.name.includes('Entry') && !((useLoginSms === CommonConstants.typePhone && store.getters['event/parentEventInfo']?.isLoginPhone) || (useLoginSms === CommonConstants.typeSms && store.getters['event/parentEventInfo']?.isLoginOnlyPhone));
  if ((to.meta?.unauthRequired || to.meta?.isLoggedSms || to.meta?.isNotLoggedSms || to.meta?.useLoginSms) && (useLoginSms || useLoginSms == 0) && store.getters['event/parentEventInfo']?.useLoginSms) {
    if ((useLoginSms !== store.getters['event/parentEventInfo']?.useLoginSms) && (isLoginStream || isEntryStream)) {
      store.dispatch('common/setErrors', [MESSAGE_MAP.isChangeUseLoginSms]);
      store.dispatch('common/openErrorModal', true);
      store.dispatch('common/setBackRouteName', null);
    }
  }
};

async function handleAuthGuard(to, from, next) {
  const token = getToken();
  if (token) {
    if (!Object.values(store.getters['auth/infor']).length) {
      await store.dispatch('auth/getUserInfor', { directory: to.params.directory });
    }
    if (store.getters['auth/isAgreed'] === false && to.params.directory && !to.meta.isIdentitySms) {
      if (store.getters['event/childEventInfo']?.useAuthentication) {
        await router.push({ name: 'Authentication' });
      } else {
        await router.push({ name: from?.name || 'Home', params: { directory: to.params.directory } })
          .catch(() => {})
          .finally(() => {
            store.dispatch('common/openTermsModal', true);
        });
      }
    } else if (to.name === 'Pincode' && !store.getters['auth/hasPasscode']) {
      return next({ name: 'PincodeDefault', query: { hasNotPasscode: true, directory: to.query.directory } });
    } else {
      return next();
    }
  } else {
    const loginRouteName = to.params.directory ? 'Login' : 'LoginParent';
    router.replace({ name: loginRouteName, params: to.params, query: to.query?.backToTop ? {} : { ...to.query, redirect: to.name } });
  }
}
async function handleUnauthGuard(to, from, next) {
  if (store.getters['auth/token']) {
    const defaultRouteName = to.params.directory ? 'Home' : 'EventList';
    return next({ name: defaultRouteName, params: { ...to.params } });
  } else if (to.name.includes('Login') && store.getters['event/useLinkageAppAndNecFlag'] && store.getters['event/nativeType']) {
    return next({ name: 'EventList' });
  } else if (['LoginParent', 'Login'].includes(to.name) && store.getters['event/parentEventInfo']?.isLoginOnlyPhone) {
    await checkIfChangeSmsLayout(to);
    return next({ name: to.params.directory ? 'LoginSms' : 'LoginSmsParent', params: { ...to.params }, query: to.query?.backToTop ? {} : { ...to.query } });
  } else if (['LoginSmsParent', 'LoginSms'].includes(to.name) && store.getters['event/parentEventInfo']?.isLoginNormal) {
    await checkIfChangeSmsLayout(to);
    return next({ name: to.params.directory ? 'Login' : 'LoginParent', params: { ...to.params }, query: to.query?.backToTop ? {} : { ...to.query } });
  } else {
    return next();
  }
}
router.beforeEach(async (to, from, next) => {
  if (window.location.href === `https://gayapon.${process.env.VUE_APP_DOMAIN}/#/404`) {
    window.location.replace(`https://gayapon.${process.env.VUE_APP_DOMAIN}/#/gayapon2026/search`);
    return next();
  }
  if (to.meta?.isScanQR) {
    await store.dispatch('common/setQrRouteData', to);
  } else {
    await store.dispatch('common/resetQrRouteData');
  }
  if (!window.location.href.includes('#') && !window.location.href.includes('/identity/finish')) {
    if (window.location.href === window.location.origin + '/') {
      window.location.href = window.location.origin + '/#' + window.location.pathname;
      location.reload();
      return;
    }
    window.location.href = window.location.origin + '/#' + window.location.pathname;
    return;
  }
  if (to.name === 'Login') {
    // router.replace({ name: to.name, params: to.params, query: { redirect: to.name } });
  }
  if ((from.name === 'EntryInputConfirm' && to.name === 'EntryConfirm') || (from.name === 'EntrySmsInputConfirm' && to.name === 'EntrySmsConfirm')) {
    location.reload();
    return;
  }
  if (((to.name !== '404' || (store.getters['common/isWebView'] || store.getters['event/useLinkageAppAndNecFlag'])) && to.name !== '500' && !store.getters['event/parentEventInfo']) || to.meta?.useVerify || to.meta?.usePincode || to.meta?.unauthRequired) {
    useLoginSms = store.getters['event/parentEventInfo']?.useLoginSms;
    await store.dispatch('event/getParentEventInfo');
  }
  document.title = store.getters['event/parentEventInfo']?.name;
  if (to.meta.eventRequired || (to.params.directory && (!store.getters['event/childEventInfo'] || to.meta.useVerify)) || to.meta?.useSms) {
    await store.dispatch('event/getChildEventInfo', { directory: to.params.directory, isHome: to.name === 'Home' ? 1 : 0 });
  }
  if (!to.params?.directory) {
    title = store.getters['event/parentEventInfo']?.name || title;
  } else {
    title = store.getters['event/childEventInfo']?.name || title;
  }
  if (['LoginParent', 'Login', 'LoginSms', 'LoginSmsParent'].includes(to.name) && to.query?.back) {
    if (!['LoginParent', 'Login', 'LoginSms', 'LoginSmsParent'].includes(from.name)) {
      localStorage.setItem('pathName', from?.fullPath);
    }
  }
  if ((['LoginParent', 'Login', 'LoginSms', 'LoginSmsParent'].includes(to.name) || to.meta?.isScanQR) && !!to.query?.qrCode) {
    sessionStorage.setItem('qrData', JSON.stringify(to?.query));
  }
  if (from.name?.includes('Login') && ['SearchCoupon', 'Search'].includes(to.name)) {
    sessionStorage.setItem('isFromLoginSms', ['LoginSms', 'LoginSmsParent'].includes(from.name));
  }
  if (['Home', 'EventList'].includes(from?.name) && to.name === 'SearchCoupon') {
    sessionStorage.setItem('isClearSearchCoupon', true);
  }
  if (checkIfRedirectUrl(to, from, next)) {
    if (checkIfRedirect404(to)) {
      return next({ name: '404' });
    } else if (to.meta.authRequired) {
      return handleAuthGuard(to, from, next);
    } else if (to.meta.unauthRequired) {
      return handleUnauthGuard(to, from, next);
    } else {
      if (
        to.name === 'Home'
        && (store.getters['event/useLinkageAppAndNecFlag'] || store.getters['event/appType'])
        && to.params?.directory
        && to.query?.token
      ) {
        await store.commit('auth/SET_TOKEN', to.query?.token);
        return next({ name: 'Home', params: { directory: to.params.directory }, query: {}});
      } else if (
        to.name === 'Home'
        && !Object.values(store.getters['auth/infor']).length
        && getToken()
        && (store.getters['common/isWebView'] || store.getters['event/useLinkageAppAndNecFlag'] || store.getters['event/appType'])
        && to.params.directory
      ) {
        const result = await store.dispatch('auth/getUserInfor', { directory: to.params.directory, isHome: 1 });
        if (!result) {
          return next();
        }
        if (!store.getters['auth/isAgreed'] && !store.getters['event/childEventInfo']?.useAuthentication) {
          store.dispatch('common/openTermsModal', true);
        }
        if (!store.getters['auth/hasPasscode'] && !(store.getters['event/parentEventInfo']?.usePaymentPasscode && !store.getters['auth/infor']?.usePaymentPasscode)) {
          return next({ name: 'PincodeDefault', query: { directory: to.params.directory} });
        }
      } else if (
        to.name === 'EventList'
        && (store.getters['event/useLinkageAppAndNecFlag'] || store.getters['event/appType'])
        && to.query?.token
        && store.getters['event/parentEventInfo']?.eventMain
      ) {
        await store.commit('auth/SET_TOKEN', to.query?.token);
        return next({ name: 'Home', params: { directory: store.getters['event/parentEventInfo']?.eventMain } });
      }
      return next();
    }
  }
});

let hasRedirected = false;
router.afterEach(async (to, from) => {
  if (hasRedirected) return;
  document.title = to.meta.title + ' | ' + title || title;
  if (
    (
      store.getters['auth/token']
      && (!Object.values(store.getters['auth/infor']).length || to.params.directory)
      && to.params.directory
      && !['NewsOfficial', 'NewsShop', 'Home'].includes(to.name)
    ) || to.meta?.useSms
  ) {
    await store.dispatch('auth/getUserInfor', { isHome: to.name === 'Home' ? 1 : 0 });
  }
  if (to.name.includes('MonitoringEntry')) {
    await store.dispatch('mimamori/getMonitoringStatus');
    if (store.getters['mimamori/isMonitoringLocked']) {
      hasRedirected = true;
      router.push({ name: 'Monitoring' });
    }
  }
  if (to.name === 'Login' || to.name === 'Authentication' || to.meta.authenticationRequired) {
    await store.dispatch('event/getChildEventInfo', { directory: to.params.directory });
  }
  const isLoggedIn = store.getters['auth/token'];
  const childEventInfo = store.getters['event/childEventInfo'];
  const parentEventInfo = store.getters['event/parentEventInfo'];
  const useAuthentication = childEventInfo?.useAuthentication;
  const isAgreed = store.getters['auth/isAgreed'];
  const authInfor = store.getters['auth/infor'];
  if ((to.name === 'Authentication' && (!useAuthentication || (isLoggedIn && isAgreed) )) ||
  (to.meta?.isMailNotRegisted && authInfor?.email) || (to.meta?.isMailRegisted && !authInfor?.email) || (parentEventInfo?.useLinkageNecFlag && !store.getters['common/isLinkageView'] && store.getters['event/nativeType'] && !['MailRegistFinish', 'MailFinish'].includes(to.name)) ||
  (to.name === 'Charge' && ((!store.getters['event/isChargeableDate'] && (!store.getters['event/childEventInfo']?.isPrepareCharge || !store.getters['auth/isCustomerTesting'])) || store.getters['event/isPaymentEventType'])) ||
  (to.meta?.isPayment && (store.getters['event/isPausedEvent'] || (!store.getters['event/isPaymentableDate'] && (!store.getters['event/childEventInfo']?.isPreparePayment || !store.getters['auth/isCustomerTesting']))))) {
    hasRedirected = true;
    router.push({ name: '404' });
  }
  if (!to.name.includes('Login') && store.getters['auth/token']) {
    if (to.params.directory) {
      if (to.name !== 'IdentityInputCodeSMS' && to.name !== 'IdentitySmsFinish' && to.name !== 'IdentitySMS' && authInfor?.isExpiredSms && childEventInfo.useSms) {
        hasRedirected = true;
        router.replace({ name: 'IdentitySMS', query: { backToTop: true } });
      } else if (to.name !== 'ChildIdentityConfirm' && (authInfor?.isExpiredIdentity && !authInfor.isExpiredSms) && !!childEventInfo?.identityVerification &&
      parentEventInfo?.useVerify && !store.getters['event/noTypeMomentIdentity']) {
        hasRedirected = true;
        router.replace({ name: 'ChildIdentityConfirm' });
      }
    } else {
      if ((to.name === 'EventList' || JSON.parse(sessionStorage.getItem('isLoginBack'))) && parentEventInfo?.events?.length && JSON.parse(localStorage.getItem('isLoginParent'))) {
        const defaultDirectory = parentEventInfo?.events?.[0]?.directory;
        await store.dispatch('auth/getUserInfor', { directory: defaultDirectory });
        if (store.getters['auth/infor']?.isExpiredSms) {
          hasRedirected = true;
          router.replace({ name: 'IdentitySMS', params: { directory: defaultDirectory }, query: JSON.parse(sessionStorage.getItem('isLoginBack')) ? { backToTop: true } : { backToEventList: true }});
        } else if ((store.getters['auth/infor']?.isExpiredIdentity && !store.getters['auth/infor'].isExpiredSms) && parentEventInfo?.useVerify) {
          hasRedirected = true;
          router.replace({ name: 'ChildIdentityConfirm', params: { directory: defaultDirectory }, query: { backToEventList: true }});
        } else {
          localStorage.removeItem('isLoginParent');
        }
      }
    }
  }
  checkIfChangeSmsLayout(to);

  if (
    to.meta.authenticationRequired &&
    useAuthentication &&
    !store.getters['auth/authenticationToken']
  ) {
    if (to.meta?.isLoggedSms) localStorage.setItem('isAuthenticationSms', true);
    hasRedirected = true;
    router.push({ name: 'Authentication' });
  }

  if ((from.name?.includes('PointFinish') || ['CurrencyFinish', 'TicketFinish'].includes(from?.name)) && to.meta?.isScanQR) {
    hasRedirected = true;
    router.push({ name: from.name?.includes('Parent') ? 'EventList' : 'Mypage' });
  }
});

export default router;
